import axios from "axios";
import { getCookie } from "../helpers/Helpers";
import { constructImagePath } from "../components/_pages/_transactions/direct-mail/utils";
import { callApiWithRetry } from "../helpers/callApiWithRetry";

const APP_AFT_TOKEN = window.appMyAccLoginAFToken;
const CAP_BASE_URL = window.capBaseUrl;
const CAP_SUBSCRIPTION_KEY = window.capSubscriptionKey;
const CAPA_BASE_URL = window.capaBaseUrl;
const ADDRESS_URL = window.autoAddressBaseUrl;
const CIAM_BASE_URL = window.ciamBaseUrl;
const MY_AUTO_ADDRESS_KEY = window.autoAddressKey;
const CIAM_APP_CODE = window.ciamApplicationCode;
const CMS_API_BASE_URL = window.cmsAPIBaseUrl;
const CMS_API_SUBSCRIPTION_KEY = window.cmsAPISubscriptionKey;
const MY_DELIVERIES_BASE_URL = window.appMyAccMyDeliveriesAPI;
const PRIVATE_DIRECT_MAIL_API_URL = window.DirectMailApiUrl;
const PUBLIC_DIRECT_MAIL_API_URL = window.DirectMailSiteApiUrl;
const PUBLIC_DIRECT_MAIL_API_KEY = window.DirectMailSiteApiUrlKey;
const DIRECT_MAIL_FILE_UPLOAD_API_URL = window.DirectMailFileUploadApiUrl;
const INT_API_BASE_URL = window.intAPIBaseUrl;
const INT_SUBSCRIPTION_KEY = window.intAPISubscriptionKey

const publicDirectMailRequestOptions = {
    headers: {
        "Ocp-Apim-Subscription-Key": PUBLIC_DIRECT_MAIL_API_KEY
    }
};

const getPrivateDirectMailRequestOptions = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
    }
});

// Function that gets a new JWT seccurity token if it has expired
const getJWTInfo = async () => {
    if (!window.apgigya?.jwtIsExpired()) {
        return true;
    }
    let res;
    // if the JWT has expired, call the JWT endpoint
    // https://developers.gigya.com/display/GD/accounts.getJWT+JS
    try {
        await new Promise(resolve => {
            window.apgigya.getSecurityToken({ callback: resolve });
        });
    } catch (err) {
        return res;
    }

    return res;
};

/**
 *
 * If a JWT token expired then the user will be unauthorised,
 * a request to get a new token will be made and the page reloaded
 * more information about JWT here: https://developers.gigya.com/display/GD/accounts.getJWT+JS
 */
const checkError = err => {
    if (err.response && err.response.status === 401) {
        window.apgigya.logout({ callback: () => {
            window.m59.logout(false);
            window.location.replace(`${window.location.origin}/myAccount/login`);
        } });
    }
    return err;
};

const checkIfUserIsRegisteredToShopApp = async () => {
    const userProfile = JSON.parse(window.sessionStorage.getItem("userProfile"));

    if (!userProfile.applications.some(app => app.applicationCode === "anpost_onlineshop")) {
        await new Promise(resolve => {
            window.m59.registerShopCustomer(() => {
                getProfile(getCookie("CIAMCustomerID")).then(res => {
                    if (res.status === 200) {
                        sessionStorage.setItem("userProfile", JSON.stringify(res.data));
                        resolve();
                    };
                });
            });
        });
    };
};

const autoCompleteAddress = (address, callback) => {
    axios.get(`${ADDRESS_URL}/autocomplete?key=${MY_AUTO_ADDRESS_KEY}&address=${address}&addressProfileName=AnPostProfile&vanityMode=false`).then(response => {
        callback(response);
    });
};

const findAddressWithName = (address, callback) => {
    axios.get(`${ADDRESS_URL}/findaddress?key=${MY_AUTO_ADDRESS_KEY}&addressElements=true&address=${address}&addressProfileName=AnPostProfile&language=EN&limit=-1`).then(response => {
        callback(response);
    });
};

const findAddress = (addressId, callback) => {
    axios.get(`${ADDRESS_URL}/findaddress?key=${MY_AUTO_ADDRESS_KEY}&addressElements=true&addressId=${addressId}&addressProfileName=AnPostProfile&language=EN&limit=0`).then(response => {
        callback(response);
    });
};

const getProfile = async uid => {
    try {
        const res = await axios.get(`${CIAM_BASE_URL}/Profile/get?UID=${uid}`, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to post profile data to API
const updateProfile = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/Profile/update`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to post phone data to API
const updatePhone = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/Phone/Update`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to post phone data to API
const insertPhone = async data => {
    try {
        const res = await axios.post(`${CIAM_BASE_URL}/Phone/Add`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// get Address
const getUserAddresses = async uid => {
    try {
        const res = await axios.get(`${CIAM_BASE_URL}/Address/get?UID=${uid}`, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to post address data to API
const insertAddress = async data => {
    try {
        const res = await axios.post(`${CIAM_BASE_URL}/Address/Add`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put new address data to API
const addAddress = async data => {
    try {
        const res = await axios.post(`${CIAM_BASE_URL}/Address/Add`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put address data to API
const updateAddress = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/Address/Update`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const updateMarketingConsents = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/MarketingConsents/UpdateConsents`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const updateProfilingConsent = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/Consents/Update`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const updateAllMarketingConsents = async data => {
    try {
        const res = await axios.put(`${CIAM_BASE_URL}/MarketingConsents/SetAll`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put address data to API
const deleteAddress = async data => {
    try {
        const res = await axios.delete(
            `${CIAM_BASE_URL}/Address/Delete?UID=${data.UID}&id=${data.id}`,
            {
                headers: {
                    "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
                }
            },
            data
        );
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to get consts for user
const getUserConsents = async uid => {
    try {
        const res = await axios.get(`${CIAM_BASE_URL}/MarketingConsents/get?UID=${uid}`, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APP_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// API call to get all transactions
const getTransactions = async (uid, { cancelToken } = {}) => {
    const SESSION_ID = window.cmsSessionId;
    const res = await axios.get(`${CAPA_BASE_URL}/TransactionHistory`, {
        params: { SessionId: SESSION_ID, CiamCustomerId: uid },
        cancelToken,
        headers: {
            "X-RequestVerificationToken": APP_AFT_TOKEN,
            Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
        }
    });
    return res;
};

// API call to get a single transaction
const getTransactionDetails = async (uid, transactionReference) => {
    const SESSION_ID = window.cmsSessionId;
    try {
        const res = await axios.get(`${CAPA_BASE_URL}/Basket`, {
            params: { SessionId: SESSION_ID, CiamCustomerId: uid, BasketReference: transactionReference },
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// get a list of countries
const getCountries = async () => {
    try {
        const res = await axios.get(`${CAP_BASE_URL}/countries`, {
            headers: {
                "Ocp-Apim-Subscription-Key": CAP_SUBSCRIPTION_KEY
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// API Favourites
const getFavourites = async uid => {
    const SESSION_ID = window.cmsSessionId;
    try {
        const res = await axios.get(`${CAPA_BASE_URL}/FavouriteReceiver`, {
            params: { SessionId: SESSION_ID, CiamCustomerId: uid },
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// API to delete a favourite
const deleteFavourite = async data => {
    try {
        const res = await axios.delete(`${CAPA_BASE_URL}/FavouriteReceiver`, {
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            },
            data
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// API call to get a single country
const addFavouriteReceiver = async data => {
    try {
        const res = await axios.post(`${CAPA_BASE_URL}/FavouriteReceiver`, data, {
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// API to delete a favourite
const updateFavourite = async data => {
    try {
        const res = await axios.put(`${CAPA_BASE_URL}/FavouriteReceiver`, data, {
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// Check if return label in the C&P basket has expired
const validateCnPBasket = async data => {
    try {
        const res = await axios.post(`${CAPA_BASE_URL}/Basket/ValidateBasket`, data, {
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: getCookie("CIAMCustomerToken")
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const getContentFromContentApi = async () => {
    const data = {
        contentPath: "/myaccount/content",
        contentFormat: "html",
        locale: "en-ie"
    };

    try {
        const res = await axios.post(`${CMS_API_BASE_URL}/Content`, data, {
            headers: {
                "Ocp-Apim-Subscription-Key": CMS_API_SUBSCRIPTION_KEY,
                "Content-Type": "application/json"
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const getShopBasket = async () => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const res = await axios.get(`${INT_API_BASE_URL}/shop/carts`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getCapBasketSummary = async uid => {
    const SESSION_ID = window.cmsSessionId;
    try {
        const res = await axios.get(`${CAPA_BASE_URL}/Basket/Summary`, {
            params: { SessionId: SESSION_ID, CiamCustomerId: uid },
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const getTrackingItems = async uid => {
    try {
        const res = await axios.get(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/trackingitems`, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const getMobileData = async uid => {
    try {
        const res = await axios.get(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/mobilenumbers`, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const registerMyDeliveriesUser = async (uid, userData) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/customers`, userData, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const getOrders = async ({ cancelToken, pageNumber = 1, pageSize = 10 } = {}) => {
    try {
        await getJWTInfo();
        const getOrdersUrl = `${PRIVATE_DIRECT_MAIL_API_URL}/Customer/GetOrders?onlyWithoutPDF=false&pageNumber=${pageNumber}&pageSize=${pageSize}&sortType=desc`;

        const res = await axios.get(getOrdersUrl, {
            cancelToken,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });

        if (res.data) return { data: res.data, error: null };
        return { data: null, error: "Something went wrong." };
    } catch (error) {
        if (error?.response?.data?.Data?.Keys?.[0]?.ErrorMessage === "No Orders found for this Customer matching the search criteria.") {
            return { data: { Data: { Orders: [], Paging: { HasNext: false, HasPrevious: false, PageNumber: 1, PageSize: 10, TotalPages: 0, TotalRecords: 0 } } }, error: null };
        }
        const message = error?.response?.data?.Message || error?.message || "Failed to get orders.";
        return { data: null, error: message };
    }
};

const getOrder = async id => {
    try {
        await getJWTInfo();
        const url = id ? `${PRIVATE_DIRECT_MAIL_API_URL}/Customer/GetOrder?orderId=${id}` : `${PRIVATE_DIRECT_MAIL_API_URL}/Customer/GetOrder`;
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });

        if (!response.ok) throw new Error("Failed to get order.");

        const json = await response.json();
        return { data: json, error: null };
    } catch (error) {
        return { error: error.message || "Failed to get order.", data: null };
    }
};

const getCustomerDataItem = async id => {
    try {
        await getJWTInfo();
        const url = `${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/GetCustomerDataItem?customerDataItemId=${id}`;
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        const json = await response.json();
        return { data: json, error: null };
    } catch (error) {
        return { error, data: null };
    }
};

/**
 * @param {object} params
 * @param {string} params.path
 * @param {string} params.uId
 */
const getFileBlob = async ({ path, uId }) => {
    try {
        await getJWTInfo();
        const response = await fetch(`${DIRECT_MAIL_FILE_UPLOAD_API_URL}/files/${uId}/download?path=/${path}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });

        if (!response.ok) throw new Error("Failed to get file.");

        const blob = await response.blob();
        return { data: blob, error: null };
    } catch (error) {
        return { data: null, error: error?.message || "Failed to get file." };
    }
};

/**
 * @param {string} uId
 */
const getFiles = async uId => {
    try {
        const url = `${DIRECT_MAIL_FILE_UPLOAD_API_URL}/files/${uId}`;

        await getJWTInfo();
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });

        if (!response.ok) throw new Error("Failed to get files.");

        const json = await response.json();
        return { data: json, error: null };
    } catch (error) {
        return { data: null, error: error?.message || "Failed to get files." };
    }
};

/**
 * @param {{
 *  uId: string,
 *  fileId: string,
 *  productType: "Admailer" | "TargetAddress"
 * }} params
 */

const checkFileStatus = async ({ uId, fileId, productType = "Admailer" }) => {
    try {
        const url = new URL(`${DIRECT_MAIL_FILE_UPLOAD_API_URL}/files/${uId}/product/status`);

        url.searchParams.set("productType", productType);
        url.searchParams.set("fileId", fileId);

        const retryOnSuccess = data => (!!data?.isValid && !!data.isFileSafeEnsured) || (!!data.isFileSafeEnsured && !data?.isValidationPending);
        const retryOnFailure = data => Object.keys(data?.errors || {}).length >= 0;

        await getJWTInfo();
        const res = await callApiWithRetry({
            url: url.toString(),
            maxRetries: 30,
            options: getPrivateDirectMailRequestOptions(),
            retryOnSuccess,
            retryOnFailure
        });

        if (!res) {
            throw new Error(`Something went wrong. Please try again later.`);
        }

        if (res?.status !== 200 || !!res?.data?.invalidReason) {
            throw new Error(res.data.invalidReason);
        }

        return { data: res.data, error: null };
    } catch (error) {
        return { data: null, error: error?.message || "Failed to get target addresses." };
    }
};

/**
 * @param {Record<string, any>} customerDataItem
 * @param {boolean} isUsingCustomDatabase
 * @param {string} customDatabaseFileId
 */
const addCustomerDataItemToOrder = async (customerDataItem, isUsingCustomDatabase, customDatabaseFileId) => {
    try {
        const userProfile = JSON.parse(window.sessionStorage.getItem("userProfile") || "{}");
        const uId = userProfile?.uid;

        if (!uId) return;

        // Customer data item id and product id of the customer data item we want to copy
        const customerDataItemId = customerDataItem?.Id;
        const productId = customerDataItem?.Product?.Id;
        const hasAdditionalCopies = Object.values(customerDataItem?.AdditionalCopies).length > 0 && customerDataItem?.AdditionalCopies?.CustomerDataItem?.Quantity > 0;

        if (!customerDataItemId || !productId) throw new Error("Invalid customer data item or product id.");

        await getJWTInfo();

        const requestOptions = getPrivateDirectMailRequestOptions();

        // Create a new order or get the existing order, get all files and templates for the product
        const [order, files, templates] = await Promise.all([
            getOrder(),
            getFiles(uId),
            axios.get(`${PUBLIC_DIRECT_MAIL_API_URL}/Product/GetTemplates?ProductIds=${productId}`, publicDirectMailRequestOptions)
        ]);

        if (order.error) throw new Error("Failed to get order.");
        if (files.error) throw new Error("Failed to get files.");
        // In case promise fails but status is 200
        if (templates?.data?.Message !== "OK") {
            throw new Error(templates?.data?.Message);
        }

        // Create a new customer data item
        const newCustomerDataItemData = {
            CustomerDataItemId: null,
            DeliveryDate: customerDataItem?.DeliveryDate,
            DeliveryAddress: customerDataItem?.DeliveryAddress,
            Name: null,
            SaveForLater: false,
            ProductId: customerDataItem?.Product?.Id,
            Quantity: customerDataItem?.Quantity,
            SizeId: customerDataItem?.Size?.Id,
            ProductTemplateId: customerDataItem?.ProductTemplate?.Id
        };

        // Get design images for the customer data item
        const bookId = `${customerDataItemId}-${productId}`;
        const designImages = files?.data?.items?.find(file => file?.bookId === bookId)?.imagePagesId || [];

        const imagePaths = designImages?.map(image =>
            constructImagePath({
                uId,
                bookId,
                file: image
            })
        );

        const ownTemplate = templates?.data?.Data.filter(template => template.Name === "Create Your Own");
        const ownTemplateId = ownTemplate?.[0]?.Id;

        // Create a new customer data item, get the template and download the design images
        const [newCustomerDataItem, template, ...designImageBlobs] = await Promise.all([
            axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateCustomerDataItem`, newCustomerDataItemData, requestOptions),
            axios.get(`${PUBLIC_DIRECT_MAIL_API_URL}/Product/GetTemplate?Id=${ownTemplateId}`, publicDirectMailRequestOptions),
            ...imagePaths.map(path => getFileBlob({ path, uId }))
        ]);

        if (newCustomerDataItem?.data?.Message !== "OK") {
            throw new Error(newCustomerDataItem?.data?.Data?.Keys?.[0]?.ErrorMessage || newCustomerDataItem?.data?.Message);
        }

        if (template?.data?.Message !== "OK") {
            throw new Error(template?.data?.Message);
        }

        if (designImageBlobs.some(blob => blob.error)) {
            throw new Error("Failed to get design images.");
        }

        const newCustomerDataItemId = newCustomerDataItem?.data?.Data?.Id;

        // Create targeting data for the new customer data item
        let targetingPromise;
        if (isUsingCustomDatabase) {
            const targeting = {
                CustomerDataItemId: newCustomerDataItemId,
                TargetingCSVPath: customDatabaseFileId
            };
            targetingPromise = axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateTargetingDataItemViaCSV`, targeting, requestOptions);
        } else {
            const targeting = {
                CustomerDataItemId: newCustomerDataItemId,
                Targeting: {
                    MapData: customerDataItem?.Targeting?.MapData || DefaultTargeting.MAP_DATA,
                    AdditionalAddress: customerDataItem?.Targeting?.AdditionalAddress || DefaultTargeting.ADDITIONAL_ADDRESS,
                    UnaddressedCopy: customerDataItem?.Targeting?.UnaddressedCopy || DefaultTargeting.UNADDRESSED_COPY
                }
            };
            targetingPromise = axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateTargetingDataItem`, targeting, requestOptions);
        }

        // Create design data for the new customer data item
        const design = {
            CustomerDataItemId: newCustomerDataItemId,
            Layouts: customerDataItem?.Design?.Layouts?.map(layout => ({
                ParentLayoutId: layout?.ParentLayoutId,
                Id: layout?.ParentLayoutId,
                SideId: layout?.Side?.Id,
                LayoutJSON: layout?.LayoutJSON,
                LayoutPreview: null
            }))
        };

        // Add a separate customer data item for additional copies if they exist
        const additionalCopiesPromise = [];

        if (hasAdditionalCopies) {
            const additionalCopiesData = {
                CustomerDataItemId: null,
                ParentCustomerDataItemId: newCustomerDataItemId, // Link new business product to newly created campaign
                DeliveryDate: customerDataItem?.AdditionalCopies?.CustomerDataItem?.DeliveryDate,
                DeliveryAddress: customerDataItem?.AdditionalCopies?.CustomerDataItem?.DeliveryAddress,
                Name: null,
                SaveForLater: false,
                ProductId: customerDataItem?.AdditionalCopies?.CustomerDataItem?.Product?.Id,
                Quantity: customerDataItem?.AdditionalCopies?.CustomerDataItem?.Quantity,
                SizeId: customerDataItem?.AdditionalCopies?.CustomerDataItem?.Size?.Id,
                ProductTemplateId: customerDataItem?.AdditionalCopies?.CustomerDataItem?.ProductTemplate?.Id
            };

            additionalCopiesPromise.push(axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateCustomerDataItem`, additionalCopiesData, requestOptions));
        }

        // Add all data
        const resolvedPromises = await Promise.all([
            ...designImageBlobs.map((blob, index) => {
                const designSideNumber = index + 1;
                const url = `${DIRECT_MAIL_FILE_UPLOAD_API_URL}/files/${uId}/ad-mailer/${newCustomerDataItemId}-${productId}/${designSideNumber}`;

                const formData = new FormData();
                formData.append("file", blob.data, `${designSideNumber}.png`);

                return axios.post(url, formData, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                        "Content-Type": "multipart/form-data"
                    }
                });
            }),
            targetingPromise,
            axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateDesignDataItem`, design, requestOptions),
            ...additionalCopiesPromise
        ]);

        // In case promise fails but status is 200
        if (resolvedPromises.some(promise => promise?.data?.Message && promise?.data?.Message !== "OK")) {
            throw new Error("Something went wrong.");
        }

        const updatedCampaign = await getCustomerDataItem(newCustomerDataItemId);

        if (updatedCampaign.error) throw new Error("Failed to update campaign.");

        const designDetails = {
            CustomerDataItemId: newCustomerDataItemId,
            DesignMetaData: [],
            Layouts: template?.data?.Data?.TemplateLayouts?.map(layout => ({
                LayoutId: updatedCampaign.data.Data?.Design?.Layouts?.find(designLayout => designLayout.ParentLayoutId === layout.Id)?.Id, // Id generated by the system
                LayoutMetaData: [],
                LayoutObjects: layout.LayoutObjects?.map(layoutObject => ({
                    ObjectId: layoutObject.ObjectId,
                    ObjectType: layoutObject.ObjectType,
                    MetaData: null,
                    ObjectMetaData: layoutObject?.MetaData?.map(metaData => ({
                        Type: metaData.Type,
                        Data: metaData.Data.join()
                    }))
                }))
            }))
        };

        const designDetailsData = await axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateDesignDataItemDetail`, designDetails, requestOptions);

        if (designDetailsData.data?.Message !== "OK") {
            throw new Error(designDetailsData?.data?.Data?.Keys?.[0]?.ErrorMessage || designDetailsData.data?.Message);
        }

        const uploadedImages = resolvedPromises.slice(0, designImageBlobs.length);

        const uploadedImagesStatusRes = await Promise.all(
            uploadedImages.map(image =>
                checkFileStatus({
                    uId,
                    fileId: image?.data?.fileId
                })
            )
        );

        if (uploadedImagesStatusRes.some(imageStatusRes => imageStatusRes.error)) {
            throw new Error("Failed to verify design images.");
        }

        const { WidthMM = 0, HeightMM = 0, MarginMM = 0 } = template?.data?.Data?.TemplateLayouts?.[0]?.Size || {};

        // Create a new PDF for the new customer data item
        const newPdfData = {
            pages: designImageBlobs.map((_, index) => index + 1),
            widthInMm: WidthMM,
            heightInMm: HeightMM,
            marginInMm: MarginMM
        };

        // Generate pdf for new customer data item and add additional copies targeting if they exist
        const pdfRes = await axios.post(`${DIRECT_MAIL_FILE_UPLOAD_API_URL}/files/${uId}/ad-mailer/${newCustomerDataItemId}-${customerDataItem.Product.Id}/pdf`, newPdfData, requestOptions);

        const pdfPath = {
            CustomerDataItemId: newCustomerDataItemId,
            PDFPath: pdfRes?.data?.pdfPath,
            PreviewPdfPath: null
        };

        const orderId = order?.data?.Data?.Id;

        // Update PDF path for new customer data item and add new customer data item to order
        const res = await Promise.all([
            axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/UpdateDesignDataItemPDFPath`, pdfPath, requestOptions),
            axios.post(`${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/AddCustomerDataItemToOrder?customerDataItemId=${newCustomerDataItemId}&orderId=${orderId}`, null, requestOptions)
        ]);

        // In case promise fails but status is 200
        if (res.some(promise => promise?.data?.Message && promise?.data?.Message !== "OK")) {
            throw new Error("Something went wrong.");
        }

        if (hasAdditionalCopies) {
            const newAdditionalCopiesCustomerDataItemId = resolvedPromises?.[resolvedPromises.length - 1]?.data?.Data?.Id;

            const newAdditionalCopies = await axios.post(
                `${PRIVATE_DIRECT_MAIL_API_URL}/ad/Customer/AddCustomerDataItemToOrder?customerDataItemId=${newAdditionalCopiesCustomerDataItemId}&orderId=${orderId}`,
                null,
                requestOptions
            );

            // In case promise fails but status is 200
            if (newAdditionalCopies?.data?.Message && newAdditionalCopies?.data?.Message !== "OK") {
                throw new Error("Something went wrong.");
            }
        }

        return { data: "Successfully added customer data item to order.", error: null };
    } catch (error) {
        return { data: null, error: error.message || "Failed to order again." };
    }
};

const MAP_DATA = {
    ResidentialCount: 0,
    CommercialCount: 0,
    TargetingRequestData: "",
    FromCSV: false
};

const ADDITIONAL_ADDRESS = {
    Address1: null,
    Address2: null,
    Address3: null,
    Address4: null,
    Address5: null,
    Address6: null,
    Eircode: null
};

const UNADDRESSED_COPY = {
    Quantity: 0,
    Address1: null,
    Address2: null,
    Address3: null,
    Address4: null,
    Address5: null,
    Address6: null,
    Eircode: null
};

const DefaultTargeting = {
    MAP_DATA,
    ADDITIONAL_ADDRESS,
    UNADDRESSED_COPY
};

/**
 * @function
 * @name getOrderInvoice
 * @param {{orderNumber: string}}
 */
const downloadDmOrderInvoice = async ({ orderNumber }) => {
    try {
        const url = new URL(`${PRIVATE_DIRECT_MAIL_API_URL}/Order/GetOrderInvoice`);
        url.searchParams.set("orderNumber", orderNumber);

        await getJWTInfo();
        const res = await axios.get(url.toString(), {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            },
            responseType: "blob"
        });

        const href = window.URL.createObjectURL(res.data);
        const name = `Direct Mail Order - ${orderNumber}.pdf`;
        const link = document.createElement("a");
        link.href = href;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
        return undefined;
    } catch (error) {
        throw new Error(error.message);
    }
};

const getShopOrders = async ({ cancelToken, offset = 0, limit = 10, downloadActive } = {}) => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const getShopOrdersUrl = `${INT_API_BASE_URL}/shop/orders?limit=${limit}&offset=${offset}&pageInfo=true&order=desc${downloadActive ? "&Scope=1" : ""}`;
        const res = await axios.get(getShopOrdersUrl, {
            cancelToken,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });

        if (res.data) return { data: res.data, error: null };
        return { data: null, error: "Something went wrong." };
    } catch (error) {
        const message = error?.response?.data?.Message || error?.message || "Failed to get orders.";
        return { data: null, error: message };
    }
};

const getShopOrder = async orderId => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const getShopOrderUrl = `${INT_API_BASE_URL}/shop/orders/${orderId}`;
        const res = await axios.get(getShopOrderUrl, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });

        if (res.data) return { data: res.data, error: null };
        return { data: null, error: "Something went wrong." };
    } catch (error) {
        const message = error?.response?.data?.error?.["error-message"] || error?.message || "Failed to get order.";
        return { data: null, error: message };
    }
};

const getCollectorsAccountNumber = async () => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const res = await axios.get(`${INT_API_BASE_URL}/shop/customers/collectors`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const updateCollectorsAccountNumber = async data => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const res = await axios.patch(`${INT_API_BASE_URL}/shop/customers/collectors`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

const downloadShopOrderInvoice = async data => {
    await checkIfUserIsRegisteredToShopApp();
    try {
        const res = await axios.post(`${INT_API_BASE_URL}/shop/orders/invoices/downloads`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            }
        });
        const contentLocationGuid = res.headers["content-location"];

        if (res.status === 202 && contentLocationGuid) {
            return contentLocationGuid;
        }
    } catch (err) {
        return console.log(err);
    }
};

const getShopOrderInvoiceFile = async (downloadGuidPath, outputFormat, isNativeAppDownload) => {
    try {
        const res = await axios.get(`${INT_API_BASE_URL}${downloadGuidPath}?outputFormat=${outputFormat}${isNativeAppDownload ? "&returnfile=false" : ""}`, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
                "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY
            },
            validateStatus: () => true
        });
        return res;
    } catch (err) {
        return console.log(err);
    }
};

export {
    downloadDmOrderInvoice,
    getFiles,
    getFileBlob,
    getOrder,
    getCustomerDataItem,
    autoCompleteAddress,
    findAddress,
    getProfile,
    updateProfile,
    updatePhone,
    updateMarketingConsents,
    updateAllMarketingConsents,
    insertPhone,
    getUserAddresses,
    insertAddress,
    updateAddress,
    getUserConsents,
    addAddress,
    deleteAddress,
    getTransactions,
    getTransactionDetails,
    getCountries,
    getFavourites,
    deleteFavourite,
    addFavouriteReceiver,
    updateFavourite,
    getJWTInfo,
    findAddressWithName,
    validateCnPBasket,
    updateProfilingConsent,
    getContentFromContentApi,
    getShopBasket,
    getCapBasketSummary,
    getTrackingItems,
    getMobileData,
    registerMyDeliveriesUser,
    getOrders,
    checkFileStatus,
    addCustomerDataItemToOrder,
    getShopOrders,
    getShopOrder,
    getCollectorsAccountNumber,
    updateCollectorsAccountNumber,
    downloadShopOrderInvoice,
    getShopOrderInvoiceFile
};

